// import { BILLING_URL } from "../../constants/apiUrls";
import { apiSlice } from "./../apiSlice";

export const billingAddressApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBillingAddressByUserId: builder.query({
      query: ({ id, token }) => ({
        url: `api/billing/addresses/list/${id}/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`
        },
      }),
    }),
    addBillingAddress: builder.mutation({
      query: ({data, token}) => ({
        url: `api/billing/addresses/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    deleteBillingAddress: builder.mutation({
      query: ({ data,token}) => ({
        url: `api/billing/delete-billing-address/${data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getBillingAddressByBillingId: builder.query({
      query: ({id, token}) => ({
        url: `api/billing/addresses/${id}/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateBillingAddressByBillingId: builder.mutation({
      query: ({data, token}) => ({
        url: `api/billing/addresses/${data?.billing_add_ID}/`,
        method: "PUT",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updatePrimaryBillingAddressByBillingId: builder.mutation({
      query: ({ data, id, token }) => ({
        url: `api/billing/primary-addresess/list/${id}/set_primary/`,
        method: "PUT",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    cancelSubscription: builder.mutation({
      query: (stripe_subscription_id) => ({
        url: `api/billing/cancel/subscription/${stripe_subscription_id}`,
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    sendMailSubscription: builder.mutation({
      query: ({ mail, stripeSubId }) => ({
        url: `api/billing/send-subscription-mail/${mail}/${stripeSubId}`,
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    checkPaymentStatus: builder.mutation({
      query: ({data, token}) => ({
        url: `api/billing/stripe-status/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

export const {
  useGetBillingAddressByUserIdQuery,
  useAddBillingAddressMutation,
  useUpdateBillingAddressByBillingIdMutation,
  useUpdatePrimaryBillingAddressByBillingIdMutation,
  useCancelSubscriptionMutation,
  useSendMailSubscriptionMutation,
  useDeleteBillingAddressMutation,
  useGetBillingAddressByBillingIdQuery,
  useCheckPaymentStatusMutation
} = billingAddressApiSlice;
